import TagIndex from '../../components/Insights/tags'
import { connect } from 'react-redux'
import { setReportDayRange, setReportWebSiteId } from '../../actions/Insights'
import { generateTag, clearInsightTagInfo, clearTagError, setTagWebsiteName, setTagWebsiteURL,
  getTagDetail, setTagCampaignName} from '../../actions/tags'

import {getClientSites, getClientTags} from '../../actions/Clients'
import {getClientInfo} from '../../actions/App'
import { push } from 'react-router-redux';

const mapStateToProps = (state) => {
  const { websiteId, dayRange, website_name, website_url, tag_info,
    tag_error_message, tag_variables, campaign_name} = state.insights;
  const { selected_client, client_info, clients, roleId } = state.app  
  const { client_sites, client_tags } = state.clients
  return {
    websiteId,
    selected_client,
    client_sites,
    dayRange,
    client_info,
    clients,
    website_name,
    website_url,
    campaign_name,
    tag_info,
    tag_variables,
    tag_error_message,
    client_tags,
    roleId
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClientSites: (cid) => {
      dispatch(getClientSites(cid, true))
    },

    setWebsiteId: (id) => {
      dispatch(setReportWebSiteId(id))
    },
    
    setDateRange: (str) => {
      dispatch(setReportDayRange(str))
    },

    setTagWebsiteName: (val) => {
      dispatch(setTagWebsiteName(val))
    },

    setTagWebsiteURL: (val) => {
      dispatch(setTagWebsiteURL(val))
    },

    setTagCampaignName: (val) => {
      dispatch(setTagCampaignName(val))
    },

    generateTag: (clientId, val) => {
      dispatch(clearTagError())
      dispatch(generateTag(clientId, val))
    },

    saveTag: (clientId, uuid, val) => {
      //dispatch(saveTag(clientId, uuid, val))
      dispatch(getClientTags(clientId))
      dispatch(push(`/insights/tags/list`))
    },

    clearInsightTagInfo: () => {
      dispatch(clearInsightTagInfo())
    },

    clearInsightTagInfoAndRefreh: (clientId) => {
      dispatch(clearInsightTagInfo())
      dispatch(getClientTags(clientId))
      dispatch(push(`/insights/tags/list`))
    },

    getClientTags: (clientId) => {
      dispatch(getClientTags(clientId))
    },
    clearTagError: () => {
      dispatch(clearTagError())
    },
    createNewTag: ()=>{
      dispatch(clearTagError())
      dispatch(clearInsightTagInfo())
      dispatch(push(`/insights/tags/create`))
    },
    getTagDetail: (clientId, tagId) => {
      dispatch(getTagDetail(clientId, tagId, undefined))
    },
    getClientInfo: (id) => {
      dispatch(getClientInfo(id))
    }
  }
}

const InsightTagsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TagIndex)

export default InsightTagsContainer;


// WEBPACK FOOTER //
// ./src/containers/Insights/Tags.js